import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useBackNavigation from "../../../../Veridas/Functionality/useBackNavigation";
import useHandleBeforeUnload from "../../../../Veridas/Functionality/useHandleBeforeUnload";
import {getMainUrl, MODEL_VERIDAS} from "../../../../Veridas/Model/Models";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const EventSuccessValidationFormApp = () => {

    const { guardFlowId, userId, eventId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userDataSuccess = useSelector((state) => state.VisitorSlice.userDataDocument);
    const validationData = useSelector((state) => state.VisitorSlice.getValidationId);
    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const [modifiedData, setModifiedData] = useState({ ...MODEL_VERIDAS });
    const [activeStep, setActiveStep] = useState(1);
    const invitationId = getInvitationById?.invitation?.id;
    const mainUrl = getMainUrl({ invitationId, guardFlowId, userId, eventId });

    /**
     * Syncs Redux user validation data into local state.
     *
     * @effect
     * @dependency {userDataSuccess} triggers update when validation data changes
     */
    useEffect(() => {
        if (userDataSuccess) {
            setModifiedData(modifiedData.set(userDataSuccess));
        }
    }, [userDataSuccess]);


    /**
     * Handles final submission and redirects user to main event flow.
     */
    const handleSubmit = () => {
        navigate(mainUrl);
    };

    useBackNavigation({ getInvitationById, validationId: validationData });
    useHandleBeforeUnload({ getInvitationById , validationId: validationData});

    return {
        t,
        modifiedData,
        activeStep,
        handleSubmit
    }

}

export default EventSuccessValidationFormApp
